module.exports = __webpack_public_path__ + "static/media/weclickd-logo-only-icon.bbf7c5b9.png";